import { render, staticRenderFns } from "./ItemsJournalTable.vue?vue&type=template&id=bc2db14a&"
import script from "./ItemsJournalTable.vue?vue&type=script&lang=js&"
export * from "./ItemsJournalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports